import { render, staticRenderFns } from "./policy-new.vue?vue&type=template&id=33f10584&scoped=true&"
import script from "./policy-new.vue?vue&type=script&lang=js&"
export * from "./policy-new.vue?vue&type=script&lang=js&"
import style0 from "./policy-new.vue?vue&type=style&index=0&id=33f10584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f10584",
  null
  
)

export default component.exports